import NandhaImg from "../../images/trainers/nandhu.png";
import {
  FaWhatsapp,
  FaInstagram,
  FaPhone,
  FaCertificate,
  FaDumbbell,
  FaHeartPulse,
} from "react-icons/fa6";

function TrainerBox() {
  const trainer = {
    img: NandhaImg,
    name: "G. Nandha Kumar",
    job: "Head Coach",
    bio: "Internationally certified fitness expert with over a decade of transforming bodies and building confidence. Train with a champion — real results, real commitment.",
    achievements: [
      "🥇 Mr. India Junior",
      "🥇 Mr. South India",
      "🥇 Mr. Tamil Nadu",
      "🥇 Mr. Coimbatore",
    ],
    certifications: [
      { Icon: FaCertificate, label: "ICREPS International Certified" },
      { Icon: FaDumbbell, label: "Certified Personal Trainer" },
      { Icon: FaHeartPulse, label: "Fitness & Lifestyle Coach" },
    ],
    instagram: "https://www.instagram.com/nk_.nandhu",
    whatsapp:
      "https://wa.me/918637488702?text=Hi%20Coach%20Nandha%2C%20I%20want%20to%20start%20my%20fitness%20journey!",
    phone: "tel:+918637488702",
  };

  return (
    <div
      className="w-full max-w-[950px] mx-auto rounded-3xl overflow-hidden shadow-2xl flex flex-col lg:flex-row bg-[#0f0f0f]"
      style={{ border: "1px solid rgba(255,3,54,0.25)" }}
    >
      {/* ── LEFT / TOP PHOTO PANEL ── */}
      <div
        className="relative w-full lg:w-[42%] h-[300px] xs:h-[360px] sm:h-[400px] lg:h-auto min-h-[300px] flex-shrink-0 overflow-hidden flex items-end justify-center"
        style={{
          background: "linear-gradient(160deg, #1a0008 0%, #0d0d0d 50%, #1a0000 100%)",
        }}
      >
        {/* Yellow/Red accent glow */}
        <div
          className="absolute -bottom-10 -left-10 w-[240px] sm:w-[280px] h-[240px] sm:h-[280px] rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(255,214,0,0.25) 0%, transparent 70%)",
          }}
        />
        {/* Coach photo */}
        <img
          src={trainer.img}
          alt={trainer.name}
          className="h-[95%] max-h-[320px] xs:max-h-[360px] sm:max-h-[400px] lg:max-h-[440px] object-contain object-bottom relative z-10"
          style={{
            filter: "drop-shadow(0 -8px 24px rgba(255,3,54,0.3))",
          }}
        />
        {/* Top badge */}
        <div
          className="absolute top-4 left-4 z-20 px-3.5 py-1 rounded-full text-[10px] sm:text-[11px] font-black uppercase tracking-widest text-black"
          style={{ background: "linear-gradient(90deg,#ffd600,#ff9100)" }}
        >
          Head Coach
        </div>
      </div>

      {/* ── RIGHT / BOTTOM INFO PANEL ── */}
      <div
        className="flex-1 flex flex-col justify-center p-6 sm:p-8 lg:p-10"
        style={{ background: "#0f0f0f" }}
      >
        {/* Name & Role */}
        <h3
          className="text-white font-extrabold leading-tight mb-1 text-[24px] sm:text-[30px] md:text-[34px]"
        >
          {trainer.name}
        </h3>
        <p
          className="font-bold uppercase tracking-widest mb-3 sm:mb-4 text-[12px] sm:text-[13px]"
          style={{ color: "#FF0336" }}
        >
          {trainer.job}
        </p>

        {/* Bio */}
        <p
          className="leading-relaxed mb-4 sm:mb-5 text-[13px] sm:text-[14px]"
          style={{ color: "#a0a0a0" }}
        >
          {trainer.bio}
        </p>

        {/* Championship Wins */}
        <p
          className="text-[10px] sm:text-[11px] uppercase font-bold tracking-widest mb-2"
          style={{ color: "#777" }}
        >
          Championship Titles
        </p>
        <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-4 sm:mb-5">
          {trainer.achievements.map((a, i) => (
            <span
              key={i}
              className="text-[11px] sm:text-[11.5px] font-semibold px-2.5 sm:px-3 py-1 rounded-full"
              style={{
                background: "rgba(255,214,0,0.08)",
                color: "#ffd600",
                border: "1px solid rgba(255,214,0,0.3)",
              }}
            >
              {a}
            </span>
          ))}
        </div>

        {/* Certifications */}
        <p
          className="text-[10px] sm:text-[11px] uppercase font-bold tracking-widest mb-2"
          style={{ color: "#777" }}
        >
          Certifications
        </p>
        <div className="flex flex-col gap-1.5 sm:gap-2 mb-5 sm:mb-6">
          {trainer.certifications.map((c, i) => (
            <div key={i} className="flex items-center gap-2.5 sm:gap-3">
              <c.Icon
                className="text-[13px] sm:text-[14px] shrink-0"
                style={{ color: "#FF0336" }}
              />
              <span className="text-[12px] sm:text-[13px]" style={{ color: "#bbb" }}>
                {c.label}
              </span>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div
          className="w-full mb-5 sm:mb-6"
          style={{ height: "1px", background: "rgba(255,255,255,0.08)" }}
        />

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href={trainer.whatsapp}
            target="_blank"
            rel="noreferrer"
            aria-label="Book a session on WhatsApp"
            className="flex-1 flex items-center justify-center gap-2 px-5 py-3.5 rounded-xl font-bold uppercase text-[12px] tracking-wider text-white transition-all duration-300 hover:opacity-90 shadow-lg"
            style={{
              background: "linear-gradient(90deg,#FF0336,#cc0228)",
            }}
          >
            <FaWhatsapp className="text-[16px]" />
            Book Free Trial
          </a>
          <div className="flex gap-2 sm:gap-3">
            <a
              href={trainer.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram Profile"
              className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-3.5 rounded-xl font-bold uppercase text-[12px] tracking-wider text-white transition-all duration-300 hover:bg-[#ffd600] hover:text-black"
              style={{
                background: "rgba(255,255,255,0.07)",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <FaInstagram className="text-[16px]" />
              <span>Instagram</span>
            </a>
            <a
              href={trainer.phone}
              aria-label="Call Coach Nandha"
              className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-3.5 rounded-xl font-bold uppercase text-[12px] tracking-wider text-white transition-all duration-300 hover:bg-[#FF0336]"
              style={{
                background: "rgba(255,255,255,0.07)",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <FaPhone className="text-[13px]" />
              <span>Call</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrainerBox;
